<main class="main">
  <section
    class="wrap-title"
    style="
      background: url('https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/05/Unidades_1920x324.png');
      background-size: cover;
    "
  >
    <div class="layout">
      <h1 class="title-page">Nossa Rede</h1>
    </div>
  </section>

  <section class="wrap-content">
    <div class="layout">
      <div class="left">
        <div class="ckeditor">
          <p>
            Atuamos em todo o território nacional como a melhor parceira para
            quem está inserido no ramo veicular. Nos principais Estados você
            encontra uma unidade Union perto da sua empresa: cobertura completa
            em diversas cidades do Brasil, levando softwares focados em soluções
            especializadas no que diz respeito a veículos.
          </p>
          <p>
            Encontre a unidade mais próxima do seu negócio através dos nossos
            canais de atendimento.
          </p>
        </div>

        <nav class="buttons">
          <a
            class="btn blue"
            target="_blank"
            rel="noopener"
            href="tel:11963056359"
            aria-label="Telefone"
            >Telefone</a
          >
          <a
            class="btn blue"
            target="_blank"
            rel="noopener"
            href="https://api.whatsapp.com/send?phone=5511963056359"
            aria-label="WhatsApp"
            >WhatsApp</a
          >
          <a
            class="btn blue"
            target="_blank"
            rel="noopener"
            aria-label="Email"
            href="mailto:atendimento@unionsolutions.com.br"
            >Email</a
          >
        </nav>
      </div>
      <div class="right">
        <img
          src="https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2023/02/mapa.png"
          width="100%"
          alt="Mapa com localização das unidades Union"
          loading="lazy"
        />
      </div>
    </div>
  </section>
  <section class="wrap-content" id="unidades">
    <div class="layout" style="justify-content: center">
      <div class="unidade" *ngFor="let unidade of unidades">
        <h2>{{ unidade.nome }}</h2>
        <div class="contato" *ngFor="let contato of unidade.contatos">
          <div *ngIf="contato.descricao" class="icone">
            <img
              [src]="contato.icone"
              [alt]="contato.descricao"
              loading="lazy"
            />
          </div>
          <div class="desc">
            <a
              *ngIf="contato.descricao"
              [href]="contato.link"
              target="_blank"
              rel="noopener"
              [attr.aria-label]="contato.descricao"
            >
              {{ contato.descricao }}
            </a>

            <a
              *ngIf="!contato.descricao"
              [href]="contato.link"
              target="_blank"
              rel="noopener"
              aria-label="Informações de contato da unidade"
            >
              Contato
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>

  <app-contact-box></app-contact-box>
</main>
